/* eslint-disable no-console */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */
import axios from "axios";
import Cookies from "universal-cookie";
import config from "../config";
import { roles } from "../lib/constants";
import { decryptString } from "./authorization";
import _store from "../redux/createStore";

export const HTTP_EXCEPTIONS = {
  NO_CONTENT: "NO_CONTENT",
  NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
  BAD_REQUEST: "BAD_REQUEST",
  CONFLICT: "CONFLICT",
  FAILED_DEPENDENCY: "FAILED_DEPENDENCY",
  NOT_FOUND: "NOT_FOUND",
  UNAUTHORIZED: "UNAUTHORIZED",
  INTERNAL_SERVER_ERROR: "INTERNAL_SERVER_ERROR",
  FORBIDDEN: "FORBIDDEN",
  NOT_MODIFIED: "NOT_MODIFIED",
};

export function getValidToken(removeServerToken) {
  const cookies = new Cookies();
  let decryptedLoginCookie;
  const loginState = cookies.get(config.cookieKeys.loginState);
  if (loginState) {
    decryptedLoginCookie = decryptString(loginState);
  }
  return new Promise((resolve, reject) => {
    if (localStorage.getItem("token") && decryptedLoginCookie !== "loggedOut") {
      resolve(localStorage.getItem("token"));
    } else if (removeServerToken) {
      resolve(localStorage.getItem("token"));
    } else {
      reject(new Error("Invalid token"));
    }
  });
}

/**
 * Handel text response , throw error if catches error in json parsing
 * @param responseText
 */
function handleTextResponse(responseText) {
  if (responseText) {
    try {
      const parsedJSON = JSON.parse(responseText);
      return parsedJSON;
    } catch (err) {
      throw new Error(responseText);
    }
  }
  return null;
}

/**
 * handles fetch response status and return text data,
 * throws error if response is not ok or
 * there  is any issue in parsing response to text
 * @param response
 * @returns {*}
 */
function handleResponseInJson(response) {
  if (response.ok) {
    if (response.status === 204) {
      return JSON.stringify({
        status: 204,
        description: "No Content Found",
      });
    }
    return response.text();
  }
  return response
    .json()
    .then((error) => {
      error.status = response.status;
      throw error;
    })
    .catch((err) => {
      if (err && !err.description) {
        err.status = response.status;
      }
      throw err;
    });
}
/**
 * handle network errors
 * @param error
 */
function handleNetworkError(error) {
  throw new Error(error.message);
}

export async function fetchWrapper(url, options) {
  return getValidToken()
    .then((token) => {
      if (options.headers) {
        options.headers.Authorization = `Bearer ${token}`;
      } else {
        options.headers = {
          Authorization: `Bearer ${token}`,
        };
      }
      return fetch(url, options)
        .then(handleResponseInJson, handleNetworkError)
        .then(handleTextResponse);
    })
    .catch((err) => {
      throw err;
    });
}

export function fetchWrapperWithoutToken(url, options) {
  return fetch(url, options)
    .then(handleResponseInJson, handleNetworkError)
    .then(handleTextResponse);
}

export async function fetchWrapperTextResponse(url, options) {
  return fetch(url, options)
    .then((response) => response.text())
    .catch((error) => {
      console.error(error);
    });
}

/**
 * returns final promise which return promise with proper exception handling
 * @param url
 * @param options
 * @returns {Promise}
 */
export function getAPIPromise(url, options) {
  return new Promise((resolve, reject) => {
    fetchWrapper(url, options)
      .then((response) => {
        if (!(HTTP_EXCEPTIONS[response.status]
          || response.status === 500
          || response.status === 204)) {
          resolve(response);
        } else {
          reject(response);
        }
      })
      .catch((err) => {
        if (err.status === 200) {
          resolve(err);
        } else {
          reject(err);
        }
      });
  });
}

export const getReconAPIPromise = async (url, { headers, method, body }) => {
  const options = {
    method, url, data: body, headers,
  };
  if (method.toLowerCase() === "get") delete options.data;
  return axios({ ...options })
    .then((res) => res)
    .catch((e) => {
      const originalErrormessage = e.message;
      if (originalErrormessage === "Network Error") {
        throw new Error(`Unable to connect with server[${url}]`);
      } else {
        const { message } = e.response.data.response.error;
        const err = new Error(message);
        throw err;
      }
    });
};

export const getNewReconAPIPromise = async (url, { headers, method, body }) => {
  const options = {
    method, url, data: body, headers,
  };
  if (method.toLowerCase() === "get") delete options.data;

  return axios({ ...options })
    .then((res) => res)
    .catch((err) => {
      const originalErrormessage = err.message;

      if (originalErrormessage === "Network Error") {
        throw new Error(`Unable to connect with server[${url}]`);
      } else {
        if (err?.message.includes("401")) {
          throw new Error("Invalid token");
        }
        const { message } = err.response.data;
        const error = new Error(message);
        throw error;
      }
    });
};

export async function reconServiceAPI(url, params, removeServerToken, multipart) {
  return getValidToken(removeServerToken)
    .then((token) => {
      let options = {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          // "Authorization": `Bearer ${token}`
        },
        body: {
          ...params,
          token,
        },
      };
      if (!multipart) {
        const store = _store.getState();
        const cityIdArrParam = params?.paramValue?.query?.addOnFilter?.cityIdArr;

        // Hot fix for wrong data on filter by Promoter issue
        if (cityIdArrParam) {
          if (
            store.Auth?.user?.role === roles.admin
            || store.Auth?.user?.role === roles.superAdmin
          ) {
            params.paramValue.query.addOnFilter.cityIdArr = cityIdArrParam;
            if (!cityIdArrParam?.length) {
              params.paramValue.query.addOnFilter.cityIdArr = store.Cities?.cities?.map(
                (city) => city.cityId.toString(),
              );
            }
          }
        }

        if (params?.type === "logout") {
          options = {
            ...options,
            body: {
              ...params,
              paramValue: { token },
              token,
            },
          };
        }
      } else {
        const formData = params;
        formData.append("token", token);
        options.headers = {
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        };
        options.body = formData;
      }
      return getReconAPIPromise(url, options);
    })
    .then((res) => {
      let data = res.data.response.result;
      if (multipart) {
        data = res.data.response;
      }
      return data;
    })
    .catch((err) => {
      throw err;
    });
}

export async function newReconServiceAPI(
  url,
  params,
  removeServerToken,
  multipart,
  noContentType = false,
) {
  return getValidToken(removeServerToken)
    .then((token) => {
      const options = {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: {
          ...params,
        },
      };
      if (!multipart && !noContentType) {
        const store = _store.getState();
        const cityIdArrParam = params?.addOnFilter?.cityIdArr;

        // Hot fix for wrong data on filter by Promoter issue
        if (cityIdArrParam) {
          params.addOnFilter.cityIdArr = (
            store.Auth?.user?.role === roles.admin
            || store.Auth?.user?.role === roles.superAdmin
          )
            ? cityIdArrParam
            : (cityIdArrParam?.length
              ? cityIdArrParam
              : store.Cities?.cities?.map((city) => city.cityId.toString()));
        }
      } else if (noContentType) {
        const formData = new FormData();
        Object.entries(params).forEach(([key, value]) => {
          formData.append(key, value);
        });
        options.body = formData;
        delete options.headers["Content-Type"];
      } else {
        const formData = params;
        formData.append("token", token);
        options.headers = {
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        };
        options.body = formData;
      }
      return getNewReconAPIPromise(url, options);
    })
    .then((res) => res.data.data || res.data)
    .catch((err) => {
      throw err;
    });
}

export async function newReconDownloadExcelAPI(url, params, removeServerToken) {
  return getValidToken(removeServerToken)
    .then((token) => axios({
      url,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/vnd.openxmlformats",
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob",
      data: {
        ...params,
      },
    })
      .then((res) => res)
      .catch((err) => {
        const originalErrormessage = err.message;
        console.log(originalErrormessage);
        if (originalErrormessage === "Network Error") {
          throw new Error("Unable to download file from server");
        } else {
          const { message } = err.response.data;
          const error = new Error(message);
          throw error;
        }
      }));
}

export function newReconGetServiceAPI(url, removeServerToken) {
  return getValidToken(removeServerToken)
    .then((token) => {
      const options = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      return getNewReconAPIPromise(url, options);
    })
    .then((res) => res.data.data || res.data)
    .catch((err) => {
      throw err;
    });
}

export async function afcsServiceAPI(url) {
  return getValidToken()
    .then(() => {
      const options = {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: {},
      };
      return getReconAPIPromise(url, options);
    })
    .then((res) => res?.data || [])
    .catch((err) => {
      throw err;
    });
}

export const getLoginAPIPromise = (url, { body }) => axios
  .post(`${url}`, body)
  .then((res) => res.data.response)
  .catch((e) => {
    const originalErrormessage = e.message;
    if (originalErrormessage === "Network Error") {
      throw new Error(`Unable to connect with server[${url}]`);
    } else {
      const { message } = e.response.data.response.error;
      const err = new Error(message);
      throw err;
    }
  });

export const getNewLoginAPIPromise = (url, { body }) => axios
  .post(`${url}`, body)
  .then((res) => {
    const { data } = res.data;
    return data;
  })
  .catch((e) => {
    const originalErrormessage = e.message;
    if (originalErrormessage === "Network Error") {
      throw new Error(`Unable to connect with server[${url}]`);
    } else {
      const { message } = e.response.data.data;
      const err = new Error(message);
      throw err;
    }
  });

